import { useCallback } from 'react';

import Icon, { ICON_RIGHT } from '~/components/icon';
import { InstantDepositInfoForMethods } from '~/components/payment/quick-deposit-beta/types';
import { textKeysQDAmountScreen } from '~/components/payment/quick-deposit-beta/utils/constants';
import { getLogo, renderAccountDetails } from '~/components/payment/quick-deposit-beta/utils/qd-helpers';
import useTranslations from '~/components/translation/use-translations';

// Styled components
import { DotElement, DotsContainer, NewQDMethodsCollapseListElementContainer, Text } from './styles';

type Props = {
	provider: InstantDepositInfoForMethods;
	selectMethodAndExecute: (provider: InstantDepositInfoForMethods) => void;
};

const NewQDMethodsCollapseListElement = ({ provider, selectMethodAndExecute }: Props) => {
	const { translations: t } = useTranslations(textKeysQDAmountScreen);
	const { accountInfo } = renderAccountDetails(provider) as { accountInfo?: string };
	const paymentMethodInfoText = accountInfo ? accountInfo.replace('*', '') : t[provider.paymentMethodNameTextKey];
	const handleOnClick = useCallback(() => selectMethodAndExecute(provider), [provider, selectMethodAndExecute]);

	return (
		<NewQDMethodsCollapseListElementContainer
			key={provider.paymentMethodNameTextKey}
			onClick={handleOnClick}
			aria-hidden="true"
			data-at={`${provider.paymentMethodNameTextKey}-paymentmethod-new-quick-deposit`}
		>
			{getLogo(provider, false, true) as React.ReactNode}
			{accountInfo && (
				<DotsContainer>
					<DotElement />
					<DotElement />
					<DotElement />
					<DotElement />
				</DotsContainer>
			)}
			<Text className="u-text-l u-flex u-no-break">{paymentMethodInfoText}</Text>
			<Icon className="u-mla" height={24} width={24} type={ICON_RIGHT} />
		</NewQDMethodsCollapseListElementContainer>
	);
};

export default NewQDMethodsCollapseListElement;
